import { render } from "./index.vue?vue&type=template&id=723d0c2b&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=723d0c2b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723d0c2b"]])

export default __exports__